import { LoadingState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: LoadingState = {
  loadingScreen: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'LOADING_SCREEN':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
